import React from 'react'
import { Link } from 'gatsby'
import { toSlug } from 'ak-react-utils'
import Markdown from '../Markdown'
import DynamicComponent from '../DynamicComponent'

const ItemTextPlain = ({item}) => {
  return (
    <div className='item-text-plain'>
      <div className='mb-4'>
        <h3 id={ toSlug(item.headline)} className='item-headline'>
          { item.headline }
        </h3>
        <Markdown className='item-body'>
          {item.body}
        </Markdown>
        { item.target_link_text && (
            <div className='item-link-block text-start mt-3 mb-4'>
              <Link to={ item.target_url } className='link-primary'>
                { item.target_link_text }
              </Link>
            </div>
        )
        }
      </div>
      { item.has_component && (
        <DynamicComponent item={item} />
      )}
    </div>
  )
}

export default ItemTextPlain
